module.exports = "pegasus_template/assets/italian-landscape-mountains-nature.png";